module.exports = __webpack_public_path__ + "img/grafana.9ae39e4.png";